import { Link } from "react-router-dom";

const Instruction = () => {
  return (
    <>
      <div className="inner-banner before-none bg-white border-top">
        <div className="container">
          <div className="inner-banner-txt">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Instructions{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <section className="main-section default-page border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-sm-12 col-xs-12">
              <div className="main-title wow fadeInUp mb-5">
                <h2 className="fs-35 wow fadeInUp fadeIn">
                  How to use Fashion hub template
                </h2>
              </div>
              <div className="privacy-policy-txt">
                <h2>Download the template</h2>
                <p>
                  {" "}
                  Find a website that offers HTML templates and download the
                  desired template file. The template may come in a compressed
                  format such as ZIP. Extract the contents of the ZIP file to a
                  folder on your computer.
                </p>
                <h3>Set up a local development environment</h3>
                <p>
                  <img src="images/inst/open.png" alt="instructions" />
                  To edit and preview the template, it's recommended to set up a
                  local development environment. You can install a local web
                  server like XAMPP (https://www.apachefriends.org/index.html)
                  or use a code editor with a built-in live preview feature like
                  Visual Studio Code (https://code.visualstudio.com/) with the
                  Live Server extension or can click on links than open in
                  browser.
                </p>
                <p>
                  Follow the installation instructions provided by the chosen
                  tool to set up the local development environment.{" "}
                </p>
                <h3>Copy the template files </h3>
                <p>
                  {" "}
                  Once you have your local development environment ready, copy
                  the template files from the extracted folder into the
                  appropriate location. This will typically be the root folder
                  of your local web server or the project folder in your code
                  editor.
                </p>
                <h3>Edit the template files</h3>
                <p>
                  Use a text editor or a code editor to open the template files
                  and make modifications according to your needs. You can edit
                  the HTML, CSS, and JavaScript files to customize the design
                  and functionality of the template.
                </p>
                <p>
                  <strong>HTML files: </strong> Modify the structure, content,
                  and placeholders of the HTML files to suit your requirements.
                  Update the text, images, links, and any other elements as
                  needed.{" "}
                </p>
                <p>
                  <strong> CSS files: </strong> Adjust the styles defined in the
                  CSS files to change the appearance of the template. Customize
                  the colors, fonts, layout, and other visual aspects.
                </p>
                <p>
                  <strong>JavaScript files: </strong> If the template includes
                  JavaScript files, you can edit them to add interactivity or
                  modify existing behavior.
                </p>
                <h3>Test the template</h3>
                <p>
                  {" "}
                  After making changes, save the template files and launch the
                  local development environment. Open the template in a web
                  browser to see the updated version. Test the different pages
                  and features of the template to ensure everything functions as
                  intended.
                </p>
                <h3>Update the template</h3>
                <p>
                  If a newer version of the template becomes available, you can
                  update it by following similar steps. Download the updated
                  template files, replace the existing files in your project
                  with the new ones, and make any necessary adjustments or
                  improvements.
                </p>
                <p>
                  Be careful when updating a template, as it may involve
                  overwriting existing files or modifying the directory
                  structure. It's recommended to create backups or work on a
                  separate copy of your project to avoid accidental data loss.{" "}
                </p>
                <p>
                  By following these steps, you can install, edit, and update a
                  downloaded HTML template to create a customized website based
                  on the template's <strong>(Fashion Hub)</strong> design and
                  functionality.
                </p>
                <div className="text-center">
                  <h4 className="tcolor">Thank You </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Instruction;
